import Icon from '@/components/ui/Icon';
import React, { useEffect, useState } from 'react';
import { LinkButton } from '@/components/ui/Buttons';
import cn from '@/utils/cn';
import { useDebounceCallback } from 'usehooks-ts';

const BackToTopIcon = () => {
  const [isAtTop, setIsAtTop] = useState(true);
  const debounceCheckAtTop = useDebounceCallback(setIsAtTop, 30);
  const handleScroll = () => {
    debounceCheckAtTop(!(document.documentElement.scrollTop > 10));
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    document.documentElement.scrollTo({ behavior: 'smooth', top: 0 });
  };

  return (
    <LinkButton
      className={cn('tw-flex tw-flex-col tw-items-center tw-fixed tw-right-4 tw-bottom-7',
        { 'tw-hidden': isAtTop }, { 'tw-fixed': !isAtTop })}
      onClick={scrollToTop}
    >
      <Icon icon="BackToTop" size={30} />
      <span className="tw-font-bold"> Back to Top </span>
    </LinkButton>
  );
};

export default BackToTopIcon;
